import { SliderPageWrapper } from "../../layout/sliderPageWrapper/SliderPageWrapper";

export const ComingSoon = () => {
  return (
    <SliderPageWrapper headerTitle="...Coming Soon..."></SliderPageWrapper>
  );
};
